import cx from 'clsx';
import React from 'react';
import config from '../../config';
import Category, {
  CategoryRendererWithSlidesPropTypes,
} from '../Category/Category';

import styles from './BingoGames.module.scss';

interface BingoGamesPropTypes extends CategoryRendererWithSlidesPropTypes {
  playButtonLabel?: string;
  playButtonLabelVisible?: boolean;
  jurisdiction?: string;
}

const BingoGames: React.FC<BingoGamesPropTypes> = ({
  playButtonLabel,
  playButtonLabelVisible,
  jurisdiction,
  ...props
}) => {
  if (!props.visible || !props.category) return null;

  const lobbyUrl = `${config.urls.bingoLobby}?language=${props.locale}&region=${jurisdiction}`;

  return (
    <div className={cx(styles.layout)} data-testid="bingo-games-wrapper">
      <Category {...props} />

      {playButtonLabelVisible && (
        <a
          className={styles.link}
          href={lobbyUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="play-bingo-button"
        >
          {playButtonLabel}
        </a>
      )}
    </div>
  );
};

export default BingoGames;
